import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';

import { Season } from 'types';

import { usersDataService } from 'services/users.service';

import { formatDateIntoStringOfNumbers } from 'helpers/formatDate';
import { sortSeasons } from 'helpers/mapSeasons';

import { routes } from 'data/routes';

import { EditForm } from 'sections/EditForm';
import { SectionType, TabWrap } from 'sections/TabWrap';

import { TabType } from 'components/Tabs';

import { addNewSeasonFormData } from './constants/constants';

export const useSeasons = () => {
  const [seasons, setSeasons] = useState<Season[]>([]);
  const navigate = useNavigate();
  const timestamp = formatDateIntoStringOfNumbers(new Date());
  const params = Object.values(useParams())[0] as string;

  const {
    register,
    control,
    handleSubmit,
    formState: { isDirty, isValid, isSubmitting },
  } = useForm();

  const addNewSeason = async (data: any) => {
    await usersDataService.addSeason({ ...data, timestamp });
    toast.success('Season added successfully!');
    navigate(routes.seasons);
  };

  const editSeason = async (data: any) => {
    console.log('editSeason', data);
  };

  const seasonSubmit = async (data: any) => {
    try {
      if (params === 'new') {
        addNewSeason(data);
        return;
      }
      editSeason(data);
    } catch (error) {
      toast.error('Error adding season');
      console.error(error);
    }
  };

  const seasonSections: SectionType[] = [
    {
      id: 1,
      content: (
        <EditForm
          data={addNewSeasonFormData}
          register={register}
          onSubmit={handleSubmit(seasonSubmit)}
          submitBtnLabel="Submit"
          control={control}
          hideUndo
          hasButtons
          isDirty={isDirty}
          isButtonsDisabled={!isValid || isSubmitting}
        />
      ),
    },
  ];

  const seasonForm = <TabWrap sections={seasonSections} />;

  const seasonTab: TabType[] = [
    {
      id: 1,
      title: 'Data',
      content: seasonForm,
    },
  ];

  const getSeasons = async () => {
    try {
      const res = await usersDataService.getSeasons();
      setSeasons(
        sortSeasons(res.data).map((season) => ({ ...season, actions: ['edit', 'delete'] }))
      );
    } catch (error) {
      console.log('getSeasons error', error);
    }
  };

  useEffect(() => {
    getSeasons();
  }, []);

  return {
    seasonTab,
    seasons,
  };
};
